module.exports = {
  AED: 'د.إ',
  ALL: 'Lek',
  ARS: '$',
  AUD: '$',
  BAM: 'KM',
  BGN: 'лв',
  BRL: 'R$',
  CAD: 'CAD$',
  CHF: 'CHF',
  CNY: '¥',
  COP: '$',
  CZK: 'Kč',
  DKK: 'kr.',
  DZD: 'دج',
  EUR: '€',
  GBP: '£',
  HKD: 'HK$',
  HRK: 'kn',
  HUF: 'Ft',
  ISK: 'kr',
  JPY: '¥',
  KRW: '₩',
  MAD: 'د.م.',
  MKD: 'ден',
  MUR: '₨',
  MXN: '$',
  MYR: 'RM',
  NOK: 'kr',
  NZD: '$',
  OMR: '﷼',
  PEN: 'S/',
  PLN: 'zł',
  RON: 'lei',
  RSD: 'RSD',
  RUB: '₽',
  SEK: 'kr',
  THB: '฿',
  TRY: '₺',
  TWD: 'NT$',
  UAH: '₴',
  USD: '$',
  VND: '₫',
  ZAR: 'R'
};
